/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ConsoleImport } from './routes/console'
import { Route as FrontImport } from './routes/_front'
import { Route as FrontIndexImport } from './routes/_front/index'
import { Route as SidebarPatientImport } from './routes/sidebar.patient'
import { Route as RedirectShopImport } from './routes/redirect.shop'
import { Route as MiniTrendImport } from './routes/mini.trend'
import { Route as ConsoleLoginImport } from './routes/console/login'
import { Route as ConsoleAuthImport } from './routes/console/_auth'
import { Route as ConsoleAuthLayoutImport } from './routes/console/_auth/_layout'
import { Route as ConsoleAuthLayoutProductImport } from './routes/console/_auth/_layout/product'
import { Route as ConsoleAuthLayoutNoPermissionImport } from './routes/console/_auth/_layout/no-permission'
import { Route as ConsoleAuthLayoutInstitutionAgentImport } from './routes/console/_auth/_layout/institution-agent'
import { Route as ConsoleAuthLayoutHospitalImport } from './routes/console/_auth/_layout/hospital'
import { Route as ConsoleAuthLayoutHealthEducationImport } from './routes/console/_auth/_layout/health-education'
import { Route as ConsoleAuthLayoutExerciseGuideImport } from './routes/console/_auth/_layout/exercise-guide'
import { Route as ConsoleAuthLayoutDashboardImport } from './routes/console/_auth/_layout/dashboard'
import { Route as ConsoleAuthLayoutCompanyImport } from './routes/console/_auth/_layout/company'
import { Route as ConsoleAuthLayoutCheckPackageImport } from './routes/console/_auth/_layout/check-package'
import { Route as ConsoleAuthLayoutAgentReviewImport } from './routes/console/_auth/_layout/agent-review'
import { Route as ConsoleAuthLayoutAgentImport } from './routes/console/_auth/_layout/agent'
import { Route as ConsoleAuthLayout403Import } from './routes/console/_auth/_layout/403'
import { Route as ConsoleAuthLayoutPatientIndexImport } from './routes/console/_auth/_layout/patient/index'
import { Route as ConsoleAuthLayoutHealthPlanIndexImport } from './routes/console/_auth/_layout/health-plan/index'
import { Route as ConsoleAuthLayoutExamIndexImport } from './routes/console/_auth/_layout/exam/index'
import { Route as ConsoleAuthLayoutSystemWeworkKfAccountImport } from './routes/console/_auth/_layout/system/wework-kf-account'
import { Route as ConsoleAuthLayoutSystemSettingsImport } from './routes/console/_auth/_layout/system/settings'
import { Route as ConsoleAuthLayoutSystemRoleImport } from './routes/console/_auth/_layout/system/role'
import { Route as ConsoleAuthLayoutSystemMenuImport } from './routes/console/_auth/_layout/system/menu'
import { Route as ConsoleAuthLayoutSystemDepartmentImport } from './routes/console/_auth/_layout/system/department'
import { Route as ConsoleAuthLayoutSystemAccountImport } from './routes/console/_auth/_layout/system/account'
import { Route as ConsoleAuthLayoutPatientMyImport } from './routes/console/_auth/_layout/patient/my'
import { Route as ConsoleAuthLayoutPatientAccountIdImport } from './routes/console/_auth/_layout/patient/$accountId'
import { Route as ConsoleAuthLayoutHealthPlanPlanIdImport } from './routes/console/_auth/_layout/health-plan/$planId'
import { Route as ConsoleAuthLayoutSystemScaleIndexImport } from './routes/console/_auth/_layout/system/scale/index'
import { Route as ConsoleAuthLayoutSystemFollowUpIndexImport } from './routes/console/_auth/_layout/system/follow-up/index'
import { Route as ConsoleAuthLayoutSystemScaleQuestionnaireIdImport } from './routes/console/_auth/_layout/system/scale/$questionnaireId'
import { Route as ConsoleAuthLayoutSystemFollowUpQuestionnaireIdImport } from './routes/console/_auth/_layout/system/follow-up/$questionnaireId'
import { Route as ConsoleAuthLayoutPatientAccountIdMonitorImport } from './routes/console/_auth/_layout/patient/$accountId_.monitor'
import { Route as ConsoleAuthLayoutPatientAccountIdArchiveImport } from './routes/console/_auth/_layout/patient/$accountId_.archive'
import { Route as ConsoleAuthLayoutHealthPlanEditPlanIdImport } from './routes/console/_auth/_layout/health-plan/edit.$planId'
import { Route as ConsoleAuthLayoutPatientAccountIdDietMetricIdImport } from './routes/console/_auth/_layout/patient/$accountId_.diet.$metricId'

// Create/Update Routes

const ConsoleRoute = ConsoleImport.update({
  id: '/console',
  path: '/console',
  getParentRoute: () => rootRoute,
} as any)

const FrontRoute = FrontImport.update({
  id: '/_front',
  getParentRoute: () => rootRoute,
} as any)

const FrontIndexRoute = FrontIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FrontRoute,
} as any)

const SidebarPatientRoute = SidebarPatientImport.update({
  id: '/sidebar/patient',
  path: '/sidebar/patient',
  getParentRoute: () => rootRoute,
} as any)

const RedirectShopRoute = RedirectShopImport.update({
  id: '/redirect/shop',
  path: '/redirect/shop',
  getParentRoute: () => rootRoute,
} as any)

const MiniTrendRoute = MiniTrendImport.update({
  id: '/mini/trend',
  path: '/mini/trend',
  getParentRoute: () => rootRoute,
} as any)

const ConsoleLoginRoute = ConsoleLoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => ConsoleRoute,
} as any)

const ConsoleAuthRoute = ConsoleAuthImport.update({
  id: '/_auth',
  getParentRoute: () => ConsoleRoute,
} as any)

const ConsoleAuthLayoutRoute = ConsoleAuthLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => ConsoleAuthRoute,
} as any)

const ConsoleAuthLayoutProductRoute = ConsoleAuthLayoutProductImport.update({
  id: '/product',
  path: '/product',
  getParentRoute: () => ConsoleAuthLayoutRoute,
} as any)

const ConsoleAuthLayoutNoPermissionRoute =
  ConsoleAuthLayoutNoPermissionImport.update({
    id: '/no-permission',
    path: '/no-permission',
    getParentRoute: () => ConsoleAuthLayoutRoute,
  } as any)

const ConsoleAuthLayoutInstitutionAgentRoute =
  ConsoleAuthLayoutInstitutionAgentImport.update({
    id: '/institution-agent',
    path: '/institution-agent',
    getParentRoute: () => ConsoleAuthLayoutRoute,
  } as any)

const ConsoleAuthLayoutHospitalRoute = ConsoleAuthLayoutHospitalImport.update({
  id: '/hospital',
  path: '/hospital',
  getParentRoute: () => ConsoleAuthLayoutRoute,
} as any)

const ConsoleAuthLayoutHealthEducationRoute =
  ConsoleAuthLayoutHealthEducationImport.update({
    id: '/health-education',
    path: '/health-education',
    getParentRoute: () => ConsoleAuthLayoutRoute,
  } as any)

const ConsoleAuthLayoutExerciseGuideRoute =
  ConsoleAuthLayoutExerciseGuideImport.update({
    id: '/exercise-guide',
    path: '/exercise-guide',
    getParentRoute: () => ConsoleAuthLayoutRoute,
  } as any)

const ConsoleAuthLayoutDashboardRoute = ConsoleAuthLayoutDashboardImport.update(
  {
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => ConsoleAuthLayoutRoute,
  } as any,
)

const ConsoleAuthLayoutCompanyRoute = ConsoleAuthLayoutCompanyImport.update({
  id: '/company',
  path: '/company',
  getParentRoute: () => ConsoleAuthLayoutRoute,
} as any)

const ConsoleAuthLayoutCheckPackageRoute =
  ConsoleAuthLayoutCheckPackageImport.update({
    id: '/check-package',
    path: '/check-package',
    getParentRoute: () => ConsoleAuthLayoutRoute,
  } as any)

const ConsoleAuthLayoutAgentReviewRoute =
  ConsoleAuthLayoutAgentReviewImport.update({
    id: '/agent-review',
    path: '/agent-review',
    getParentRoute: () => ConsoleAuthLayoutRoute,
  } as any)

const ConsoleAuthLayoutAgentRoute = ConsoleAuthLayoutAgentImport.update({
  id: '/agent',
  path: '/agent',
  getParentRoute: () => ConsoleAuthLayoutRoute,
} as any)

const ConsoleAuthLayout403Route = ConsoleAuthLayout403Import.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => ConsoleAuthLayoutRoute,
} as any)

const ConsoleAuthLayoutPatientIndexRoute =
  ConsoleAuthLayoutPatientIndexImport.update({
    id: '/patient/',
    path: '/patient/',
    getParentRoute: () => ConsoleAuthLayoutRoute,
  } as any)

const ConsoleAuthLayoutHealthPlanIndexRoute =
  ConsoleAuthLayoutHealthPlanIndexImport.update({
    id: '/health-plan/',
    path: '/health-plan/',
    getParentRoute: () => ConsoleAuthLayoutRoute,
  } as any)

const ConsoleAuthLayoutExamIndexRoute = ConsoleAuthLayoutExamIndexImport.update(
  {
    id: '/exam/',
    path: '/exam/',
    getParentRoute: () => ConsoleAuthLayoutRoute,
  } as any,
)

const ConsoleAuthLayoutSystemWeworkKfAccountRoute =
  ConsoleAuthLayoutSystemWeworkKfAccountImport.update({
    id: '/system/wework-kf-account',
    path: '/system/wework-kf-account',
    getParentRoute: () => ConsoleAuthLayoutRoute,
  } as any)

const ConsoleAuthLayoutSystemSettingsRoute =
  ConsoleAuthLayoutSystemSettingsImport.update({
    id: '/system/settings',
    path: '/system/settings',
    getParentRoute: () => ConsoleAuthLayoutRoute,
  } as any)

const ConsoleAuthLayoutSystemRoleRoute =
  ConsoleAuthLayoutSystemRoleImport.update({
    id: '/system/role',
    path: '/system/role',
    getParentRoute: () => ConsoleAuthLayoutRoute,
  } as any)

const ConsoleAuthLayoutSystemMenuRoute =
  ConsoleAuthLayoutSystemMenuImport.update({
    id: '/system/menu',
    path: '/system/menu',
    getParentRoute: () => ConsoleAuthLayoutRoute,
  } as any)

const ConsoleAuthLayoutSystemDepartmentRoute =
  ConsoleAuthLayoutSystemDepartmentImport.update({
    id: '/system/department',
    path: '/system/department',
    getParentRoute: () => ConsoleAuthLayoutRoute,
  } as any)

const ConsoleAuthLayoutSystemAccountRoute =
  ConsoleAuthLayoutSystemAccountImport.update({
    id: '/system/account',
    path: '/system/account',
    getParentRoute: () => ConsoleAuthLayoutRoute,
  } as any)

const ConsoleAuthLayoutPatientMyRoute = ConsoleAuthLayoutPatientMyImport.update(
  {
    id: '/patient/my',
    path: '/patient/my',
    getParentRoute: () => ConsoleAuthLayoutRoute,
  } as any,
)

const ConsoleAuthLayoutPatientAccountIdRoute =
  ConsoleAuthLayoutPatientAccountIdImport.update({
    id: '/patient/$accountId',
    path: '/patient/$accountId',
    getParentRoute: () => ConsoleAuthLayoutRoute,
  } as any)

const ConsoleAuthLayoutHealthPlanPlanIdRoute =
  ConsoleAuthLayoutHealthPlanPlanIdImport.update({
    id: '/health-plan/$planId',
    path: '/health-plan/$planId',
    getParentRoute: () => ConsoleAuthLayoutRoute,
  } as any)

const ConsoleAuthLayoutSystemScaleIndexRoute =
  ConsoleAuthLayoutSystemScaleIndexImport.update({
    id: '/system/scale/',
    path: '/system/scale/',
    getParentRoute: () => ConsoleAuthLayoutRoute,
  } as any)

const ConsoleAuthLayoutSystemFollowUpIndexRoute =
  ConsoleAuthLayoutSystemFollowUpIndexImport.update({
    id: '/system/follow-up/',
    path: '/system/follow-up/',
    getParentRoute: () => ConsoleAuthLayoutRoute,
  } as any)

const ConsoleAuthLayoutSystemScaleQuestionnaireIdRoute =
  ConsoleAuthLayoutSystemScaleQuestionnaireIdImport.update({
    id: '/system/scale/$questionnaireId',
    path: '/system/scale/$questionnaireId',
    getParentRoute: () => ConsoleAuthLayoutRoute,
  } as any)

const ConsoleAuthLayoutSystemFollowUpQuestionnaireIdRoute =
  ConsoleAuthLayoutSystemFollowUpQuestionnaireIdImport.update({
    id: '/system/follow-up/$questionnaireId',
    path: '/system/follow-up/$questionnaireId',
    getParentRoute: () => ConsoleAuthLayoutRoute,
  } as any)

const ConsoleAuthLayoutPatientAccountIdMonitorRoute =
  ConsoleAuthLayoutPatientAccountIdMonitorImport.update({
    id: '/patient/$accountId_/monitor',
    path: '/patient/$accountId/monitor',
    getParentRoute: () => ConsoleAuthLayoutRoute,
  } as any)

const ConsoleAuthLayoutPatientAccountIdArchiveRoute =
  ConsoleAuthLayoutPatientAccountIdArchiveImport.update({
    id: '/patient/$accountId_/archive',
    path: '/patient/$accountId/archive',
    getParentRoute: () => ConsoleAuthLayoutRoute,
  } as any)

const ConsoleAuthLayoutHealthPlanEditPlanIdRoute =
  ConsoleAuthLayoutHealthPlanEditPlanIdImport.update({
    id: '/health-plan/edit/$planId',
    path: '/health-plan/edit/$planId',
    getParentRoute: () => ConsoleAuthLayoutRoute,
  } as any)

const ConsoleAuthLayoutPatientAccountIdDietMetricIdRoute =
  ConsoleAuthLayoutPatientAccountIdDietMetricIdImport.update({
    id: '/patient/$accountId_/diet/$metricId',
    path: '/patient/$accountId/diet/$metricId',
    getParentRoute: () => ConsoleAuthLayoutRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_front': {
      id: '/_front'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof FrontImport
      parentRoute: typeof rootRoute
    }
    '/console': {
      id: '/console'
      path: '/console'
      fullPath: '/console'
      preLoaderRoute: typeof ConsoleImport
      parentRoute: typeof rootRoute
    }
    '/console/_auth': {
      id: '/console/_auth'
      path: ''
      fullPath: '/console'
      preLoaderRoute: typeof ConsoleAuthImport
      parentRoute: typeof ConsoleImport
    }
    '/console/login': {
      id: '/console/login'
      path: '/login'
      fullPath: '/console/login'
      preLoaderRoute: typeof ConsoleLoginImport
      parentRoute: typeof ConsoleImport
    }
    '/mini/trend': {
      id: '/mini/trend'
      path: '/mini/trend'
      fullPath: '/mini/trend'
      preLoaderRoute: typeof MiniTrendImport
      parentRoute: typeof rootRoute
    }
    '/redirect/shop': {
      id: '/redirect/shop'
      path: '/redirect/shop'
      fullPath: '/redirect/shop'
      preLoaderRoute: typeof RedirectShopImport
      parentRoute: typeof rootRoute
    }
    '/sidebar/patient': {
      id: '/sidebar/patient'
      path: '/sidebar/patient'
      fullPath: '/sidebar/patient'
      preLoaderRoute: typeof SidebarPatientImport
      parentRoute: typeof rootRoute
    }
    '/_front/': {
      id: '/_front/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof FrontIndexImport
      parentRoute: typeof FrontImport
    }
    '/console/_auth/_layout': {
      id: '/console/_auth/_layout'
      path: ''
      fullPath: '/console'
      preLoaderRoute: typeof ConsoleAuthLayoutImport
      parentRoute: typeof ConsoleAuthImport
    }
    '/console/_auth/_layout/403': {
      id: '/console/_auth/_layout/403'
      path: '/403'
      fullPath: '/console/403'
      preLoaderRoute: typeof ConsoleAuthLayout403Import
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/agent': {
      id: '/console/_auth/_layout/agent'
      path: '/agent'
      fullPath: '/console/agent'
      preLoaderRoute: typeof ConsoleAuthLayoutAgentImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/agent-review': {
      id: '/console/_auth/_layout/agent-review'
      path: '/agent-review'
      fullPath: '/console/agent-review'
      preLoaderRoute: typeof ConsoleAuthLayoutAgentReviewImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/check-package': {
      id: '/console/_auth/_layout/check-package'
      path: '/check-package'
      fullPath: '/console/check-package'
      preLoaderRoute: typeof ConsoleAuthLayoutCheckPackageImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/company': {
      id: '/console/_auth/_layout/company'
      path: '/company'
      fullPath: '/console/company'
      preLoaderRoute: typeof ConsoleAuthLayoutCompanyImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/dashboard': {
      id: '/console/_auth/_layout/dashboard'
      path: '/dashboard'
      fullPath: '/console/dashboard'
      preLoaderRoute: typeof ConsoleAuthLayoutDashboardImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/exercise-guide': {
      id: '/console/_auth/_layout/exercise-guide'
      path: '/exercise-guide'
      fullPath: '/console/exercise-guide'
      preLoaderRoute: typeof ConsoleAuthLayoutExerciseGuideImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/health-education': {
      id: '/console/_auth/_layout/health-education'
      path: '/health-education'
      fullPath: '/console/health-education'
      preLoaderRoute: typeof ConsoleAuthLayoutHealthEducationImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/hospital': {
      id: '/console/_auth/_layout/hospital'
      path: '/hospital'
      fullPath: '/console/hospital'
      preLoaderRoute: typeof ConsoleAuthLayoutHospitalImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/institution-agent': {
      id: '/console/_auth/_layout/institution-agent'
      path: '/institution-agent'
      fullPath: '/console/institution-agent'
      preLoaderRoute: typeof ConsoleAuthLayoutInstitutionAgentImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/no-permission': {
      id: '/console/_auth/_layout/no-permission'
      path: '/no-permission'
      fullPath: '/console/no-permission'
      preLoaderRoute: typeof ConsoleAuthLayoutNoPermissionImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/product': {
      id: '/console/_auth/_layout/product'
      path: '/product'
      fullPath: '/console/product'
      preLoaderRoute: typeof ConsoleAuthLayoutProductImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/health-plan/$planId': {
      id: '/console/_auth/_layout/health-plan/$planId'
      path: '/health-plan/$planId'
      fullPath: '/console/health-plan/$planId'
      preLoaderRoute: typeof ConsoleAuthLayoutHealthPlanPlanIdImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/patient/$accountId': {
      id: '/console/_auth/_layout/patient/$accountId'
      path: '/patient/$accountId'
      fullPath: '/console/patient/$accountId'
      preLoaderRoute: typeof ConsoleAuthLayoutPatientAccountIdImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/patient/my': {
      id: '/console/_auth/_layout/patient/my'
      path: '/patient/my'
      fullPath: '/console/patient/my'
      preLoaderRoute: typeof ConsoleAuthLayoutPatientMyImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/system/account': {
      id: '/console/_auth/_layout/system/account'
      path: '/system/account'
      fullPath: '/console/system/account'
      preLoaderRoute: typeof ConsoleAuthLayoutSystemAccountImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/system/department': {
      id: '/console/_auth/_layout/system/department'
      path: '/system/department'
      fullPath: '/console/system/department'
      preLoaderRoute: typeof ConsoleAuthLayoutSystemDepartmentImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/system/menu': {
      id: '/console/_auth/_layout/system/menu'
      path: '/system/menu'
      fullPath: '/console/system/menu'
      preLoaderRoute: typeof ConsoleAuthLayoutSystemMenuImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/system/role': {
      id: '/console/_auth/_layout/system/role'
      path: '/system/role'
      fullPath: '/console/system/role'
      preLoaderRoute: typeof ConsoleAuthLayoutSystemRoleImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/system/settings': {
      id: '/console/_auth/_layout/system/settings'
      path: '/system/settings'
      fullPath: '/console/system/settings'
      preLoaderRoute: typeof ConsoleAuthLayoutSystemSettingsImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/system/wework-kf-account': {
      id: '/console/_auth/_layout/system/wework-kf-account'
      path: '/system/wework-kf-account'
      fullPath: '/console/system/wework-kf-account'
      preLoaderRoute: typeof ConsoleAuthLayoutSystemWeworkKfAccountImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/exam/': {
      id: '/console/_auth/_layout/exam/'
      path: '/exam'
      fullPath: '/console/exam'
      preLoaderRoute: typeof ConsoleAuthLayoutExamIndexImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/health-plan/': {
      id: '/console/_auth/_layout/health-plan/'
      path: '/health-plan'
      fullPath: '/console/health-plan'
      preLoaderRoute: typeof ConsoleAuthLayoutHealthPlanIndexImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/patient/': {
      id: '/console/_auth/_layout/patient/'
      path: '/patient'
      fullPath: '/console/patient'
      preLoaderRoute: typeof ConsoleAuthLayoutPatientIndexImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/health-plan/edit/$planId': {
      id: '/console/_auth/_layout/health-plan/edit/$planId'
      path: '/health-plan/edit/$planId'
      fullPath: '/console/health-plan/edit/$planId'
      preLoaderRoute: typeof ConsoleAuthLayoutHealthPlanEditPlanIdImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/patient/$accountId_/archive': {
      id: '/console/_auth/_layout/patient/$accountId_/archive'
      path: '/patient/$accountId/archive'
      fullPath: '/console/patient/$accountId/archive'
      preLoaderRoute: typeof ConsoleAuthLayoutPatientAccountIdArchiveImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/patient/$accountId_/monitor': {
      id: '/console/_auth/_layout/patient/$accountId_/monitor'
      path: '/patient/$accountId/monitor'
      fullPath: '/console/patient/$accountId/monitor'
      preLoaderRoute: typeof ConsoleAuthLayoutPatientAccountIdMonitorImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/system/follow-up/$questionnaireId': {
      id: '/console/_auth/_layout/system/follow-up/$questionnaireId'
      path: '/system/follow-up/$questionnaireId'
      fullPath: '/console/system/follow-up/$questionnaireId'
      preLoaderRoute: typeof ConsoleAuthLayoutSystemFollowUpQuestionnaireIdImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/system/scale/$questionnaireId': {
      id: '/console/_auth/_layout/system/scale/$questionnaireId'
      path: '/system/scale/$questionnaireId'
      fullPath: '/console/system/scale/$questionnaireId'
      preLoaderRoute: typeof ConsoleAuthLayoutSystemScaleQuestionnaireIdImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/system/follow-up/': {
      id: '/console/_auth/_layout/system/follow-up/'
      path: '/system/follow-up'
      fullPath: '/console/system/follow-up'
      preLoaderRoute: typeof ConsoleAuthLayoutSystemFollowUpIndexImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/system/scale/': {
      id: '/console/_auth/_layout/system/scale/'
      path: '/system/scale'
      fullPath: '/console/system/scale'
      preLoaderRoute: typeof ConsoleAuthLayoutSystemScaleIndexImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
    '/console/_auth/_layout/patient/$accountId_/diet/$metricId': {
      id: '/console/_auth/_layout/patient/$accountId_/diet/$metricId'
      path: '/patient/$accountId/diet/$metricId'
      fullPath: '/console/patient/$accountId/diet/$metricId'
      preLoaderRoute: typeof ConsoleAuthLayoutPatientAccountIdDietMetricIdImport
      parentRoute: typeof ConsoleAuthLayoutImport
    }
  }
}

// Create and export the route tree

interface FrontRouteChildren {
  FrontIndexRoute: typeof FrontIndexRoute
}

const FrontRouteChildren: FrontRouteChildren = {
  FrontIndexRoute: FrontIndexRoute,
}

const FrontRouteWithChildren = FrontRoute._addFileChildren(FrontRouteChildren)

interface ConsoleAuthLayoutRouteChildren {
  ConsoleAuthLayout403Route: typeof ConsoleAuthLayout403Route
  ConsoleAuthLayoutAgentRoute: typeof ConsoleAuthLayoutAgentRoute
  ConsoleAuthLayoutAgentReviewRoute: typeof ConsoleAuthLayoutAgentReviewRoute
  ConsoleAuthLayoutCheckPackageRoute: typeof ConsoleAuthLayoutCheckPackageRoute
  ConsoleAuthLayoutCompanyRoute: typeof ConsoleAuthLayoutCompanyRoute
  ConsoleAuthLayoutDashboardRoute: typeof ConsoleAuthLayoutDashboardRoute
  ConsoleAuthLayoutExerciseGuideRoute: typeof ConsoleAuthLayoutExerciseGuideRoute
  ConsoleAuthLayoutHealthEducationRoute: typeof ConsoleAuthLayoutHealthEducationRoute
  ConsoleAuthLayoutHospitalRoute: typeof ConsoleAuthLayoutHospitalRoute
  ConsoleAuthLayoutInstitutionAgentRoute: typeof ConsoleAuthLayoutInstitutionAgentRoute
  ConsoleAuthLayoutNoPermissionRoute: typeof ConsoleAuthLayoutNoPermissionRoute
  ConsoleAuthLayoutProductRoute: typeof ConsoleAuthLayoutProductRoute
  ConsoleAuthLayoutHealthPlanPlanIdRoute: typeof ConsoleAuthLayoutHealthPlanPlanIdRoute
  ConsoleAuthLayoutPatientAccountIdRoute: typeof ConsoleAuthLayoutPatientAccountIdRoute
  ConsoleAuthLayoutPatientMyRoute: typeof ConsoleAuthLayoutPatientMyRoute
  ConsoleAuthLayoutSystemAccountRoute: typeof ConsoleAuthLayoutSystemAccountRoute
  ConsoleAuthLayoutSystemDepartmentRoute: typeof ConsoleAuthLayoutSystemDepartmentRoute
  ConsoleAuthLayoutSystemMenuRoute: typeof ConsoleAuthLayoutSystemMenuRoute
  ConsoleAuthLayoutSystemRoleRoute: typeof ConsoleAuthLayoutSystemRoleRoute
  ConsoleAuthLayoutSystemSettingsRoute: typeof ConsoleAuthLayoutSystemSettingsRoute
  ConsoleAuthLayoutSystemWeworkKfAccountRoute: typeof ConsoleAuthLayoutSystemWeworkKfAccountRoute
  ConsoleAuthLayoutExamIndexRoute: typeof ConsoleAuthLayoutExamIndexRoute
  ConsoleAuthLayoutHealthPlanIndexRoute: typeof ConsoleAuthLayoutHealthPlanIndexRoute
  ConsoleAuthLayoutPatientIndexRoute: typeof ConsoleAuthLayoutPatientIndexRoute
  ConsoleAuthLayoutHealthPlanEditPlanIdRoute: typeof ConsoleAuthLayoutHealthPlanEditPlanIdRoute
  ConsoleAuthLayoutPatientAccountIdArchiveRoute: typeof ConsoleAuthLayoutPatientAccountIdArchiveRoute
  ConsoleAuthLayoutPatientAccountIdMonitorRoute: typeof ConsoleAuthLayoutPatientAccountIdMonitorRoute
  ConsoleAuthLayoutSystemFollowUpQuestionnaireIdRoute: typeof ConsoleAuthLayoutSystemFollowUpQuestionnaireIdRoute
  ConsoleAuthLayoutSystemScaleQuestionnaireIdRoute: typeof ConsoleAuthLayoutSystemScaleQuestionnaireIdRoute
  ConsoleAuthLayoutSystemFollowUpIndexRoute: typeof ConsoleAuthLayoutSystemFollowUpIndexRoute
  ConsoleAuthLayoutSystemScaleIndexRoute: typeof ConsoleAuthLayoutSystemScaleIndexRoute
  ConsoleAuthLayoutPatientAccountIdDietMetricIdRoute: typeof ConsoleAuthLayoutPatientAccountIdDietMetricIdRoute
}

const ConsoleAuthLayoutRouteChildren: ConsoleAuthLayoutRouteChildren = {
  ConsoleAuthLayout403Route: ConsoleAuthLayout403Route,
  ConsoleAuthLayoutAgentRoute: ConsoleAuthLayoutAgentRoute,
  ConsoleAuthLayoutAgentReviewRoute: ConsoleAuthLayoutAgentReviewRoute,
  ConsoleAuthLayoutCheckPackageRoute: ConsoleAuthLayoutCheckPackageRoute,
  ConsoleAuthLayoutCompanyRoute: ConsoleAuthLayoutCompanyRoute,
  ConsoleAuthLayoutDashboardRoute: ConsoleAuthLayoutDashboardRoute,
  ConsoleAuthLayoutExerciseGuideRoute: ConsoleAuthLayoutExerciseGuideRoute,
  ConsoleAuthLayoutHealthEducationRoute: ConsoleAuthLayoutHealthEducationRoute,
  ConsoleAuthLayoutHospitalRoute: ConsoleAuthLayoutHospitalRoute,
  ConsoleAuthLayoutInstitutionAgentRoute:
    ConsoleAuthLayoutInstitutionAgentRoute,
  ConsoleAuthLayoutNoPermissionRoute: ConsoleAuthLayoutNoPermissionRoute,
  ConsoleAuthLayoutProductRoute: ConsoleAuthLayoutProductRoute,
  ConsoleAuthLayoutHealthPlanPlanIdRoute:
    ConsoleAuthLayoutHealthPlanPlanIdRoute,
  ConsoleAuthLayoutPatientAccountIdRoute:
    ConsoleAuthLayoutPatientAccountIdRoute,
  ConsoleAuthLayoutPatientMyRoute: ConsoleAuthLayoutPatientMyRoute,
  ConsoleAuthLayoutSystemAccountRoute: ConsoleAuthLayoutSystemAccountRoute,
  ConsoleAuthLayoutSystemDepartmentRoute:
    ConsoleAuthLayoutSystemDepartmentRoute,
  ConsoleAuthLayoutSystemMenuRoute: ConsoleAuthLayoutSystemMenuRoute,
  ConsoleAuthLayoutSystemRoleRoute: ConsoleAuthLayoutSystemRoleRoute,
  ConsoleAuthLayoutSystemSettingsRoute: ConsoleAuthLayoutSystemSettingsRoute,
  ConsoleAuthLayoutSystemWeworkKfAccountRoute:
    ConsoleAuthLayoutSystemWeworkKfAccountRoute,
  ConsoleAuthLayoutExamIndexRoute: ConsoleAuthLayoutExamIndexRoute,
  ConsoleAuthLayoutHealthPlanIndexRoute: ConsoleAuthLayoutHealthPlanIndexRoute,
  ConsoleAuthLayoutPatientIndexRoute: ConsoleAuthLayoutPatientIndexRoute,
  ConsoleAuthLayoutHealthPlanEditPlanIdRoute:
    ConsoleAuthLayoutHealthPlanEditPlanIdRoute,
  ConsoleAuthLayoutPatientAccountIdArchiveRoute:
    ConsoleAuthLayoutPatientAccountIdArchiveRoute,
  ConsoleAuthLayoutPatientAccountIdMonitorRoute:
    ConsoleAuthLayoutPatientAccountIdMonitorRoute,
  ConsoleAuthLayoutSystemFollowUpQuestionnaireIdRoute:
    ConsoleAuthLayoutSystemFollowUpQuestionnaireIdRoute,
  ConsoleAuthLayoutSystemScaleQuestionnaireIdRoute:
    ConsoleAuthLayoutSystemScaleQuestionnaireIdRoute,
  ConsoleAuthLayoutSystemFollowUpIndexRoute:
    ConsoleAuthLayoutSystemFollowUpIndexRoute,
  ConsoleAuthLayoutSystemScaleIndexRoute:
    ConsoleAuthLayoutSystemScaleIndexRoute,
  ConsoleAuthLayoutPatientAccountIdDietMetricIdRoute:
    ConsoleAuthLayoutPatientAccountIdDietMetricIdRoute,
}

const ConsoleAuthLayoutRouteWithChildren =
  ConsoleAuthLayoutRoute._addFileChildren(ConsoleAuthLayoutRouteChildren)

interface ConsoleAuthRouteChildren {
  ConsoleAuthLayoutRoute: typeof ConsoleAuthLayoutRouteWithChildren
}

const ConsoleAuthRouteChildren: ConsoleAuthRouteChildren = {
  ConsoleAuthLayoutRoute: ConsoleAuthLayoutRouteWithChildren,
}

const ConsoleAuthRouteWithChildren = ConsoleAuthRoute._addFileChildren(
  ConsoleAuthRouteChildren,
)

interface ConsoleRouteChildren {
  ConsoleAuthRoute: typeof ConsoleAuthRouteWithChildren
  ConsoleLoginRoute: typeof ConsoleLoginRoute
}

const ConsoleRouteChildren: ConsoleRouteChildren = {
  ConsoleAuthRoute: ConsoleAuthRouteWithChildren,
  ConsoleLoginRoute: ConsoleLoginRoute,
}

const ConsoleRouteWithChildren =
  ConsoleRoute._addFileChildren(ConsoleRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof FrontRouteWithChildren
  '/console': typeof ConsoleAuthLayoutRouteWithChildren
  '/console/login': typeof ConsoleLoginRoute
  '/mini/trend': typeof MiniTrendRoute
  '/redirect/shop': typeof RedirectShopRoute
  '/sidebar/patient': typeof SidebarPatientRoute
  '/': typeof FrontIndexRoute
  '/console/403': typeof ConsoleAuthLayout403Route
  '/console/agent': typeof ConsoleAuthLayoutAgentRoute
  '/console/agent-review': typeof ConsoleAuthLayoutAgentReviewRoute
  '/console/check-package': typeof ConsoleAuthLayoutCheckPackageRoute
  '/console/company': typeof ConsoleAuthLayoutCompanyRoute
  '/console/dashboard': typeof ConsoleAuthLayoutDashboardRoute
  '/console/exercise-guide': typeof ConsoleAuthLayoutExerciseGuideRoute
  '/console/health-education': typeof ConsoleAuthLayoutHealthEducationRoute
  '/console/hospital': typeof ConsoleAuthLayoutHospitalRoute
  '/console/institution-agent': typeof ConsoleAuthLayoutInstitutionAgentRoute
  '/console/no-permission': typeof ConsoleAuthLayoutNoPermissionRoute
  '/console/product': typeof ConsoleAuthLayoutProductRoute
  '/console/health-plan/$planId': typeof ConsoleAuthLayoutHealthPlanPlanIdRoute
  '/console/patient/$accountId': typeof ConsoleAuthLayoutPatientAccountIdRoute
  '/console/patient/my': typeof ConsoleAuthLayoutPatientMyRoute
  '/console/system/account': typeof ConsoleAuthLayoutSystemAccountRoute
  '/console/system/department': typeof ConsoleAuthLayoutSystemDepartmentRoute
  '/console/system/menu': typeof ConsoleAuthLayoutSystemMenuRoute
  '/console/system/role': typeof ConsoleAuthLayoutSystemRoleRoute
  '/console/system/settings': typeof ConsoleAuthLayoutSystemSettingsRoute
  '/console/system/wework-kf-account': typeof ConsoleAuthLayoutSystemWeworkKfAccountRoute
  '/console/exam': typeof ConsoleAuthLayoutExamIndexRoute
  '/console/health-plan': typeof ConsoleAuthLayoutHealthPlanIndexRoute
  '/console/patient': typeof ConsoleAuthLayoutPatientIndexRoute
  '/console/health-plan/edit/$planId': typeof ConsoleAuthLayoutHealthPlanEditPlanIdRoute
  '/console/patient/$accountId/archive': typeof ConsoleAuthLayoutPatientAccountIdArchiveRoute
  '/console/patient/$accountId/monitor': typeof ConsoleAuthLayoutPatientAccountIdMonitorRoute
  '/console/system/follow-up/$questionnaireId': typeof ConsoleAuthLayoutSystemFollowUpQuestionnaireIdRoute
  '/console/system/scale/$questionnaireId': typeof ConsoleAuthLayoutSystemScaleQuestionnaireIdRoute
  '/console/system/follow-up': typeof ConsoleAuthLayoutSystemFollowUpIndexRoute
  '/console/system/scale': typeof ConsoleAuthLayoutSystemScaleIndexRoute
  '/console/patient/$accountId/diet/$metricId': typeof ConsoleAuthLayoutPatientAccountIdDietMetricIdRoute
}

export interface FileRoutesByTo {
  '/console': typeof ConsoleAuthLayoutRouteWithChildren
  '/console/login': typeof ConsoleLoginRoute
  '/mini/trend': typeof MiniTrendRoute
  '/redirect/shop': typeof RedirectShopRoute
  '/sidebar/patient': typeof SidebarPatientRoute
  '/': typeof FrontIndexRoute
  '/console/403': typeof ConsoleAuthLayout403Route
  '/console/agent': typeof ConsoleAuthLayoutAgentRoute
  '/console/agent-review': typeof ConsoleAuthLayoutAgentReviewRoute
  '/console/check-package': typeof ConsoleAuthLayoutCheckPackageRoute
  '/console/company': typeof ConsoleAuthLayoutCompanyRoute
  '/console/dashboard': typeof ConsoleAuthLayoutDashboardRoute
  '/console/exercise-guide': typeof ConsoleAuthLayoutExerciseGuideRoute
  '/console/health-education': typeof ConsoleAuthLayoutHealthEducationRoute
  '/console/hospital': typeof ConsoleAuthLayoutHospitalRoute
  '/console/institution-agent': typeof ConsoleAuthLayoutInstitutionAgentRoute
  '/console/no-permission': typeof ConsoleAuthLayoutNoPermissionRoute
  '/console/product': typeof ConsoleAuthLayoutProductRoute
  '/console/health-plan/$planId': typeof ConsoleAuthLayoutHealthPlanPlanIdRoute
  '/console/patient/$accountId': typeof ConsoleAuthLayoutPatientAccountIdRoute
  '/console/patient/my': typeof ConsoleAuthLayoutPatientMyRoute
  '/console/system/account': typeof ConsoleAuthLayoutSystemAccountRoute
  '/console/system/department': typeof ConsoleAuthLayoutSystemDepartmentRoute
  '/console/system/menu': typeof ConsoleAuthLayoutSystemMenuRoute
  '/console/system/role': typeof ConsoleAuthLayoutSystemRoleRoute
  '/console/system/settings': typeof ConsoleAuthLayoutSystemSettingsRoute
  '/console/system/wework-kf-account': typeof ConsoleAuthLayoutSystemWeworkKfAccountRoute
  '/console/exam': typeof ConsoleAuthLayoutExamIndexRoute
  '/console/health-plan': typeof ConsoleAuthLayoutHealthPlanIndexRoute
  '/console/patient': typeof ConsoleAuthLayoutPatientIndexRoute
  '/console/health-plan/edit/$planId': typeof ConsoleAuthLayoutHealthPlanEditPlanIdRoute
  '/console/patient/$accountId/archive': typeof ConsoleAuthLayoutPatientAccountIdArchiveRoute
  '/console/patient/$accountId/monitor': typeof ConsoleAuthLayoutPatientAccountIdMonitorRoute
  '/console/system/follow-up/$questionnaireId': typeof ConsoleAuthLayoutSystemFollowUpQuestionnaireIdRoute
  '/console/system/scale/$questionnaireId': typeof ConsoleAuthLayoutSystemScaleQuestionnaireIdRoute
  '/console/system/follow-up': typeof ConsoleAuthLayoutSystemFollowUpIndexRoute
  '/console/system/scale': typeof ConsoleAuthLayoutSystemScaleIndexRoute
  '/console/patient/$accountId/diet/$metricId': typeof ConsoleAuthLayoutPatientAccountIdDietMetricIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_front': typeof FrontRouteWithChildren
  '/console': typeof ConsoleRouteWithChildren
  '/console/_auth': typeof ConsoleAuthRouteWithChildren
  '/console/login': typeof ConsoleLoginRoute
  '/mini/trend': typeof MiniTrendRoute
  '/redirect/shop': typeof RedirectShopRoute
  '/sidebar/patient': typeof SidebarPatientRoute
  '/_front/': typeof FrontIndexRoute
  '/console/_auth/_layout': typeof ConsoleAuthLayoutRouteWithChildren
  '/console/_auth/_layout/403': typeof ConsoleAuthLayout403Route
  '/console/_auth/_layout/agent': typeof ConsoleAuthLayoutAgentRoute
  '/console/_auth/_layout/agent-review': typeof ConsoleAuthLayoutAgentReviewRoute
  '/console/_auth/_layout/check-package': typeof ConsoleAuthLayoutCheckPackageRoute
  '/console/_auth/_layout/company': typeof ConsoleAuthLayoutCompanyRoute
  '/console/_auth/_layout/dashboard': typeof ConsoleAuthLayoutDashboardRoute
  '/console/_auth/_layout/exercise-guide': typeof ConsoleAuthLayoutExerciseGuideRoute
  '/console/_auth/_layout/health-education': typeof ConsoleAuthLayoutHealthEducationRoute
  '/console/_auth/_layout/hospital': typeof ConsoleAuthLayoutHospitalRoute
  '/console/_auth/_layout/institution-agent': typeof ConsoleAuthLayoutInstitutionAgentRoute
  '/console/_auth/_layout/no-permission': typeof ConsoleAuthLayoutNoPermissionRoute
  '/console/_auth/_layout/product': typeof ConsoleAuthLayoutProductRoute
  '/console/_auth/_layout/health-plan/$planId': typeof ConsoleAuthLayoutHealthPlanPlanIdRoute
  '/console/_auth/_layout/patient/$accountId': typeof ConsoleAuthLayoutPatientAccountIdRoute
  '/console/_auth/_layout/patient/my': typeof ConsoleAuthLayoutPatientMyRoute
  '/console/_auth/_layout/system/account': typeof ConsoleAuthLayoutSystemAccountRoute
  '/console/_auth/_layout/system/department': typeof ConsoleAuthLayoutSystemDepartmentRoute
  '/console/_auth/_layout/system/menu': typeof ConsoleAuthLayoutSystemMenuRoute
  '/console/_auth/_layout/system/role': typeof ConsoleAuthLayoutSystemRoleRoute
  '/console/_auth/_layout/system/settings': typeof ConsoleAuthLayoutSystemSettingsRoute
  '/console/_auth/_layout/system/wework-kf-account': typeof ConsoleAuthLayoutSystemWeworkKfAccountRoute
  '/console/_auth/_layout/exam/': typeof ConsoleAuthLayoutExamIndexRoute
  '/console/_auth/_layout/health-plan/': typeof ConsoleAuthLayoutHealthPlanIndexRoute
  '/console/_auth/_layout/patient/': typeof ConsoleAuthLayoutPatientIndexRoute
  '/console/_auth/_layout/health-plan/edit/$planId': typeof ConsoleAuthLayoutHealthPlanEditPlanIdRoute
  '/console/_auth/_layout/patient/$accountId_/archive': typeof ConsoleAuthLayoutPatientAccountIdArchiveRoute
  '/console/_auth/_layout/patient/$accountId_/monitor': typeof ConsoleAuthLayoutPatientAccountIdMonitorRoute
  '/console/_auth/_layout/system/follow-up/$questionnaireId': typeof ConsoleAuthLayoutSystemFollowUpQuestionnaireIdRoute
  '/console/_auth/_layout/system/scale/$questionnaireId': typeof ConsoleAuthLayoutSystemScaleQuestionnaireIdRoute
  '/console/_auth/_layout/system/follow-up/': typeof ConsoleAuthLayoutSystemFollowUpIndexRoute
  '/console/_auth/_layout/system/scale/': typeof ConsoleAuthLayoutSystemScaleIndexRoute
  '/console/_auth/_layout/patient/$accountId_/diet/$metricId': typeof ConsoleAuthLayoutPatientAccountIdDietMetricIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/console'
    | '/console/login'
    | '/mini/trend'
    | '/redirect/shop'
    | '/sidebar/patient'
    | '/'
    | '/console/403'
    | '/console/agent'
    | '/console/agent-review'
    | '/console/check-package'
    | '/console/company'
    | '/console/dashboard'
    | '/console/exercise-guide'
    | '/console/health-education'
    | '/console/hospital'
    | '/console/institution-agent'
    | '/console/no-permission'
    | '/console/product'
    | '/console/health-plan/$planId'
    | '/console/patient/$accountId'
    | '/console/patient/my'
    | '/console/system/account'
    | '/console/system/department'
    | '/console/system/menu'
    | '/console/system/role'
    | '/console/system/settings'
    | '/console/system/wework-kf-account'
    | '/console/exam'
    | '/console/health-plan'
    | '/console/patient'
    | '/console/health-plan/edit/$planId'
    | '/console/patient/$accountId/archive'
    | '/console/patient/$accountId/monitor'
    | '/console/system/follow-up/$questionnaireId'
    | '/console/system/scale/$questionnaireId'
    | '/console/system/follow-up'
    | '/console/system/scale'
    | '/console/patient/$accountId/diet/$metricId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/console'
    | '/console/login'
    | '/mini/trend'
    | '/redirect/shop'
    | '/sidebar/patient'
    | '/'
    | '/console/403'
    | '/console/agent'
    | '/console/agent-review'
    | '/console/check-package'
    | '/console/company'
    | '/console/dashboard'
    | '/console/exercise-guide'
    | '/console/health-education'
    | '/console/hospital'
    | '/console/institution-agent'
    | '/console/no-permission'
    | '/console/product'
    | '/console/health-plan/$planId'
    | '/console/patient/$accountId'
    | '/console/patient/my'
    | '/console/system/account'
    | '/console/system/department'
    | '/console/system/menu'
    | '/console/system/role'
    | '/console/system/settings'
    | '/console/system/wework-kf-account'
    | '/console/exam'
    | '/console/health-plan'
    | '/console/patient'
    | '/console/health-plan/edit/$planId'
    | '/console/patient/$accountId/archive'
    | '/console/patient/$accountId/monitor'
    | '/console/system/follow-up/$questionnaireId'
    | '/console/system/scale/$questionnaireId'
    | '/console/system/follow-up'
    | '/console/system/scale'
    | '/console/patient/$accountId/diet/$metricId'
  id:
    | '__root__'
    | '/_front'
    | '/console'
    | '/console/_auth'
    | '/console/login'
    | '/mini/trend'
    | '/redirect/shop'
    | '/sidebar/patient'
    | '/_front/'
    | '/console/_auth/_layout'
    | '/console/_auth/_layout/403'
    | '/console/_auth/_layout/agent'
    | '/console/_auth/_layout/agent-review'
    | '/console/_auth/_layout/check-package'
    | '/console/_auth/_layout/company'
    | '/console/_auth/_layout/dashboard'
    | '/console/_auth/_layout/exercise-guide'
    | '/console/_auth/_layout/health-education'
    | '/console/_auth/_layout/hospital'
    | '/console/_auth/_layout/institution-agent'
    | '/console/_auth/_layout/no-permission'
    | '/console/_auth/_layout/product'
    | '/console/_auth/_layout/health-plan/$planId'
    | '/console/_auth/_layout/patient/$accountId'
    | '/console/_auth/_layout/patient/my'
    | '/console/_auth/_layout/system/account'
    | '/console/_auth/_layout/system/department'
    | '/console/_auth/_layout/system/menu'
    | '/console/_auth/_layout/system/role'
    | '/console/_auth/_layout/system/settings'
    | '/console/_auth/_layout/system/wework-kf-account'
    | '/console/_auth/_layout/exam/'
    | '/console/_auth/_layout/health-plan/'
    | '/console/_auth/_layout/patient/'
    | '/console/_auth/_layout/health-plan/edit/$planId'
    | '/console/_auth/_layout/patient/$accountId_/archive'
    | '/console/_auth/_layout/patient/$accountId_/monitor'
    | '/console/_auth/_layout/system/follow-up/$questionnaireId'
    | '/console/_auth/_layout/system/scale/$questionnaireId'
    | '/console/_auth/_layout/system/follow-up/'
    | '/console/_auth/_layout/system/scale/'
    | '/console/_auth/_layout/patient/$accountId_/diet/$metricId'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  FrontRoute: typeof FrontRouteWithChildren
  ConsoleRoute: typeof ConsoleRouteWithChildren
  MiniTrendRoute: typeof MiniTrendRoute
  RedirectShopRoute: typeof RedirectShopRoute
  SidebarPatientRoute: typeof SidebarPatientRoute
}

const rootRouteChildren: RootRouteChildren = {
  FrontRoute: FrontRouteWithChildren,
  ConsoleRoute: ConsoleRouteWithChildren,
  MiniTrendRoute: MiniTrendRoute,
  RedirectShopRoute: RedirectShopRoute,
  SidebarPatientRoute: SidebarPatientRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_front",
        "/console",
        "/mini/trend",
        "/redirect/shop",
        "/sidebar/patient"
      ]
    },
    "/_front": {
      "filePath": "_front.tsx",
      "children": [
        "/_front/"
      ]
    },
    "/console": {
      "filePath": "console.tsx",
      "children": [
        "/console/_auth",
        "/console/login"
      ]
    },
    "/console/_auth": {
      "filePath": "console/_auth.tsx",
      "parent": "/console",
      "children": [
        "/console/_auth/_layout"
      ]
    },
    "/console/login": {
      "filePath": "console/login.tsx",
      "parent": "/console"
    },
    "/mini/trend": {
      "filePath": "mini.trend.tsx"
    },
    "/redirect/shop": {
      "filePath": "redirect.shop.tsx"
    },
    "/sidebar/patient": {
      "filePath": "sidebar.patient.tsx"
    },
    "/_front/": {
      "filePath": "_front/index.tsx",
      "parent": "/_front"
    },
    "/console/_auth/_layout": {
      "filePath": "console/_auth/_layout.tsx",
      "parent": "/console/_auth",
      "children": [
        "/console/_auth/_layout/403",
        "/console/_auth/_layout/agent",
        "/console/_auth/_layout/agent-review",
        "/console/_auth/_layout/check-package",
        "/console/_auth/_layout/company",
        "/console/_auth/_layout/dashboard",
        "/console/_auth/_layout/exercise-guide",
        "/console/_auth/_layout/health-education",
        "/console/_auth/_layout/hospital",
        "/console/_auth/_layout/institution-agent",
        "/console/_auth/_layout/no-permission",
        "/console/_auth/_layout/product",
        "/console/_auth/_layout/health-plan/$planId",
        "/console/_auth/_layout/patient/$accountId",
        "/console/_auth/_layout/patient/my",
        "/console/_auth/_layout/system/account",
        "/console/_auth/_layout/system/department",
        "/console/_auth/_layout/system/menu",
        "/console/_auth/_layout/system/role",
        "/console/_auth/_layout/system/settings",
        "/console/_auth/_layout/system/wework-kf-account",
        "/console/_auth/_layout/exam/",
        "/console/_auth/_layout/health-plan/",
        "/console/_auth/_layout/patient/",
        "/console/_auth/_layout/health-plan/edit/$planId",
        "/console/_auth/_layout/patient/$accountId_/archive",
        "/console/_auth/_layout/patient/$accountId_/monitor",
        "/console/_auth/_layout/system/follow-up/$questionnaireId",
        "/console/_auth/_layout/system/scale/$questionnaireId",
        "/console/_auth/_layout/system/follow-up/",
        "/console/_auth/_layout/system/scale/",
        "/console/_auth/_layout/patient/$accountId_/diet/$metricId"
      ]
    },
    "/console/_auth/_layout/403": {
      "filePath": "console/_auth/_layout/403.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/agent": {
      "filePath": "console/_auth/_layout/agent.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/agent-review": {
      "filePath": "console/_auth/_layout/agent-review.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/check-package": {
      "filePath": "console/_auth/_layout/check-package.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/company": {
      "filePath": "console/_auth/_layout/company.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/dashboard": {
      "filePath": "console/_auth/_layout/dashboard.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/exercise-guide": {
      "filePath": "console/_auth/_layout/exercise-guide.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/health-education": {
      "filePath": "console/_auth/_layout/health-education.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/hospital": {
      "filePath": "console/_auth/_layout/hospital.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/institution-agent": {
      "filePath": "console/_auth/_layout/institution-agent.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/no-permission": {
      "filePath": "console/_auth/_layout/no-permission.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/product": {
      "filePath": "console/_auth/_layout/product.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/health-plan/$planId": {
      "filePath": "console/_auth/_layout/health-plan/$planId.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/patient/$accountId": {
      "filePath": "console/_auth/_layout/patient/$accountId.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/patient/my": {
      "filePath": "console/_auth/_layout/patient/my.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/system/account": {
      "filePath": "console/_auth/_layout/system/account.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/system/department": {
      "filePath": "console/_auth/_layout/system/department.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/system/menu": {
      "filePath": "console/_auth/_layout/system/menu.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/system/role": {
      "filePath": "console/_auth/_layout/system/role.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/system/settings": {
      "filePath": "console/_auth/_layout/system/settings.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/system/wework-kf-account": {
      "filePath": "console/_auth/_layout/system/wework-kf-account.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/exam/": {
      "filePath": "console/_auth/_layout/exam/index.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/health-plan/": {
      "filePath": "console/_auth/_layout/health-plan/index.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/patient/": {
      "filePath": "console/_auth/_layout/patient/index.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/health-plan/edit/$planId": {
      "filePath": "console/_auth/_layout/health-plan/edit.$planId.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/patient/$accountId_/archive": {
      "filePath": "console/_auth/_layout/patient/$accountId_.archive.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/patient/$accountId_/monitor": {
      "filePath": "console/_auth/_layout/patient/$accountId_.monitor.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/system/follow-up/$questionnaireId": {
      "filePath": "console/_auth/_layout/system/follow-up/$questionnaireId.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/system/scale/$questionnaireId": {
      "filePath": "console/_auth/_layout/system/scale/$questionnaireId.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/system/follow-up/": {
      "filePath": "console/_auth/_layout/system/follow-up/index.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/system/scale/": {
      "filePath": "console/_auth/_layout/system/scale/index.tsx",
      "parent": "/console/_auth/_layout"
    },
    "/console/_auth/_layout/patient/$accountId_/diet/$metricId": {
      "filePath": "console/_auth/_layout/patient/$accountId_.diet.$metricId.tsx",
      "parent": "/console/_auth/_layout"
    }
  }
}
ROUTE_MANIFEST_END */
